import { connect } from 'react-redux';
import { assign } from 'lodash';
import BaseForm from '../BaseForm/BaseForm';
import {
  updateVehicleType,
  showError,
  clearErrors,
} from '../../redux/actions/vehicleTypes';

class VehicleTypeUpdateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: updateVehicleType,
      name: 'Type',
      action: 'Update',
      type: 'update',
      isTypeForm: false,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    let result = data;
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.name)) {
      this.setState({ errors: ['name'] });
      this.props.dispatch(showError('Please specify a name'));
      return false;
    }
    if (isIndex(1) && BaseForm.validator.isEmpty(data.website_slug)) {
      this.setState({ errors: ['website_slug'] });
      this.props.dispatch(showError('Please specify a website slug'));
      return false;
    }
    if (isIndex(2) && BaseForm.validator.isEmpty(data.full_name)) {
      this.setState({ errors: ['full_name'] });
      this.props.dispatch(showError('Please specify a full name'));
      return false;
    }
    if (isIndex(3) && isNaN(Number(data.size))) {
      this.setState({ errors: ['size'] });
      this.props.dispatch(showError('Please specify the size of the vehicle'));
      return false;
    }
    if (data.image && data.image.length > 0) {
      const image = data.image[0];
      result = assign({}, data, { image });
      if (isIndex(4) && !BaseForm.validator.contains(image.type, 'image')) {
        this.setState({ errors: ['image'] });
        this.props.dispatch(showError('Please choose a valid image file'));
        return false;
      }
      if (isIndex(4) && image.size >= 5 * 1024 * 1024) {
        this.setState({ errors: ['image'] });
        this.props.dispatch(showError('Please choose an image under 5MB'));
        return false;
      }
    }
    if (isIndex(5) && isNaN(Number(data.one_to_two_days))) {
      this.setState({ errors: ['one_to_two_days'] });
      this.props.dispatch(showError('Please specify a price for one to two days'));
      return false;
    }
    if (isIndex(6) && isNaN(Number(data.one_to_two_days))) {
      this.setState({ errors: ['three_to_six_days'] });
      this.props.dispatch(showError('Please specify a price for one to two days'));
      return false;
    }
    if (isIndex(7) && isNaN(Number(data.seven_days))) {
      this.setState({ errors: ['seven_days'] });
      this.props.dispatch(
        showError('Please specify a price for seven days or more'),
      );
      return false;
    }
    return result;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    dispatch(actions.change('update.name', this.props.item.name));
    dispatch(
      actions.change('update.website_slug', this.props.item.website_slug),
    );
    dispatch(actions.change('update.full_name', this.props.item.full_name));
    dispatch(actions.change('update.size', this.props.item.size));
    dispatch(actions.change('update.image', undefined));
    dispatch(actions.change(
      'update.one_to_two_days', this.props.item.one_to_two_days || '0')
    );
    dispatch(actions.change(
      'update.three_to_six_days', this.props.item.three_to_six_days || '0')
    );
    dispatch(
      actions.change('update.seven_days', this.props.item.seven_days || '0'),
    );
  }
}

const mapStateToProps = ({ vehicleTypes }) => ({
  model: vehicleTypes,
  fields: BaseForm.fields.vehicleTypes.update,
  values: {},
});

export default connect(mapStateToProps)(VehicleTypeUpdateForm);
